<template>
  <v-col v-if="demandes">
    <!--<v-row
      ><v-col
        ><v-alert prominent outlined type="info" elevation="2"
          >Votre numéro de téléphone portable personnel pourra être utilisé en
          cas d'urgence (Article L712-2, Code de l'éducation)</v-alert
        >
      </v-col>
    </v-row>-->
    <v-row>
      <v-col cols="4">
        <v-text-field
          :value="
            telephonePortableActuel == undefined ||
            telephonePortableActuel == ''
              ? ' '
              : telephonePortableActuel
          "
          label="Numéro de téléphone portable actuel"
          readonly
        ></v-text-field>
      </v-col>
      <v-form
        lazy-validation
        ref="formTelephone"
        v-model="validFormTelephone"
        @submit.prevent
      >
        <div class="ma-auto position-relative" style="max-width: 400px">
          <span class="font-weight-bold"
            >Nouveau numéro de téléphone mobile/GSM <br />(choisir le
            pays)</span
          >
          <!-- <v-otp-input
            label="Nouveau numéro de téléphone portable"
            v-model="depotPiece.libelle"
            length="10"
            @finish="onFinishTelephone"
            :rules="[
              (value) => !!value || 'Champ requis.',
              (value) =>
                (value && value.length > 9) || 'Le numéro n\'est pas complet.',
              (value) =>
                /0[6-7]\d{8}/.test(value) ||
                'Veuillez rentrer uniquement des chiffres',
            ]"
          ></v-otp-input> -->
          <PhoneInput ref="phoneInput" v-model="depotPiece.libelle" />
          <p>
            <v-btn
              small
              class="mx-2"
              :disabled="!validFormTelephone"
              color="success"
              @click="validerFormTelephone"
              ><v-icon left>mdi-magnify</v-icon>Valider</v-btn
            >
            <v-btn small class="mx-2" color="warning" @click="annulerTelephone"
              ><v-icon left>mdi-cancel</v-icon>Annuler</v-btn
            >
          </p>
          <!--<v-alert prominent outlined type="error" elevation="2"
            >Si vous supprimez votre téléphone portable, vous ne pourrez pas
            être contacté en cas d'urgence.</v-alert
          >-->
          <p>
            <v-btn small class="mx-2" color="error" @click="suprimmerTelephone"
              ><v-icon left>mdi-delete</v-icon>Supprimer le téléphone
              portable</v-btn
            >
          </p>
        </div>
        <v-overlay absolute :value="loading">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-overlay>
      </v-form>
    </v-row>

    <v-data-table
      v-if="demandes && isAdmin"
      :headers="headers"
      :items="demandes"
    >
      <template v-slot:[`item.validation`]="{}">
        <v-chip color="success">Transmis</v-chip>
      </template>
    </v-data-table>
  </v-col>
</template>

<script>
import ApiDepotPieceRepository from "@/repositories/ApiDepotPieceRepository";
import { mapState } from "vuex";
import PhoneInput from "../components/PhoneInput.vue";

export default {
  components: { PhoneInput },
  props: {
    telephonePortableActuel: {
      type: String,
      required: false,
      default: "",
    },
  },
  data() {
    return {
      loading: false,
      validFormTelephone: false,
      depotPiece: {
        type: "",
        libelle: null,
        validation: 1,
      },
      headers: [
        {
          text: "Numéro",
          value: "id",
        },
        {
          text: "Type",
          value: "type",
        },
        {
          text: "Date",
          value: "createAt",
        },
        {
          text: "Statut",
          value: "validation",
        },
        {
          text: "Libelle",
          value: "libelle",
        },
      ],
      demandes: null,
      rb1: "oui",
      rb2: "non",
      rb3: "non",
      rb4: "non",
      rb5: "non",
    };
  },
  async created() {
    this.demandes = await ApiDepotPieceRepository.getDemandesByType(
      "telephone"
    );
    this.demandes = this.demandes.reverse();
    this.depotPiece.type = "telephone";
    await this.formatDate();
  },
  computed: {
    ...mapState(["isAdmin"]),
  },
  methods: {
    validerFormTelephone() {
      const phoneComp = this.$refs.phoneInput;
      if (phoneComp.validate()) {
        this.depotPiece.libelle = this.remplacerCodePays(
          this.depotPiece.libelle
        );
        this.$confirm(
          "<strong>Confirmez-vous la modification ? </strong><br/>" +
            this.depotPiece.libelle +
            "<br/>Cliquez sur 'Oui' pour confirmer votre modification ou sur 'Non' pour revenir à l'écran précédent."
        ).then(async (response) => {
          if (response) {
            this.loading = true;
            this.demandes.unshift(
              await ApiDepotPieceRepository.saveAdresse(this.depotPiece)
            );
            this.demandes[0].createAt = this.formatOneDate(
              this.demandes[0].createAt
            );
            this.$refs.formTelephone.reset();
            this.$router.push({ name: "individu-data" });
            this.loading = false;
          }
        });
        //console.log("------Valide");
      }
    },
    remplacerCodePays(texte) {
      // L'expression régulière /^\\+33/ signifie :
      // ^      : début de la chaîne
      // \\+    : le caractère '+' (doit être échappé dans l'expression régulière)
      // 33     : les chiffres '33'
      const regex = /^\+33/;

      // On remplace la correspondance trouvée par '0'
      return texte.replace(regex, "0");
    },
    onFinishTelephone(val) {
      // utile pour le copier/coller
      this.depotPiece.libelle = val;
    },
    suprimmerTelephone() {
      this.$confirm(
        "<strong>Etes vous sûre de vouloir supprimer votre numéro de téléphone portable? </strong><br/>" +
          "Cliquez sur 'Supprimer' pour confirmer la suppression.",
        {
          color: "error",
          icon: "error",
          title: "SUPPRESSION",
          buttonTrueText: "Supprimer",
          buttonFalseText: "Annuler",
        }
      ).then(async (response) => {
        if (response) {
          this.loading = true;
          this.depotPiece.libelle = "";
          this.demandes.unshift(
            await ApiDepotPieceRepository.saveAdresse(this.depotPiece)
          );
          this.demandes[0].createAt = this.formatOneDate(
            this.demandes[0].createAt
          );
          this.$refs.formTelephone.reset();
          this.$router.push({ name: "individu-data" });
          this.loading = false;
        }
      });
    },
    annulerTelephone() {
      this.$refs.formTelephone.reset();
      this.$router.push({ name: "individu-data" });
    },
    formatDate() {
      this.demandes.forEach((demande) => {
        let dateFormatDate = new Date(Date.parse(demande.createAt));
        demande.createAt = dateFormatDate.toLocaleDateString("fr-FR", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "numeric",
          minute: "numeric",
        });
      });
    },
    formatOneDate(date) {
      let dateFormatDate = new Date(Date.parse(date));
      dateFormatDate = dateFormatDate.toLocaleDateString("fr-FR", {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "numeric",
        minute: "numeric",
      });
      return dateFormatDate;
    },
  },
};
</script>
